/* PackIndex (toile) — class-name contract implementation for @core/packs/PackIndex, on toile's
   stage tokens. Minimal, text-only: no cards, no images. Mirrors ovid's own module. */

$maxw: 1200px;
$gutter: 26px;

.root {
    max-width: $maxw;
    width: 100%;
    margin: 0 auto;
    padding: 0 $gutter 40px;
    box-sizing: border-box;
}

.summary {
    cursor: pointer;
    font-family: var(--tl-font);
    font-size: 13px;
    font-weight: 500;
    color: var(--tl-dim);
    padding: 12px 0;
    list-style: none;
    user-select: none;

    &::-webkit-details-marker {
        display: none;
    }

    &::before {
        content: '+';
        display: inline-block;
        width: 1em;
        color: var(--tl-accent);
    }

    .root[open] > &::before {
        content: '\2212';
    }

    &:hover {
        color: var(--tl-text);
    }
}

.groups {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 20px 28px;
    padding-top: 14px;
    border-top: 1px solid var(--tl-border);
}

.group {
    min-width: 0;
}

.groupTitle {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--tl-dim);
    margin: 0 0 8px;
}

.list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

/* No per-link `class` is rendered (see PackIndex.tsx's own comment on why) — style every anchor
   through this descendant selector instead. */
.list a {
    font-family: var(--tl-font);
    font-size: 13px;
    color: var(--tl-muted);
    text-decoration: none;

    &:hover {
        color: var(--tl-accent);
        text-decoration: underline;
    }
}
